// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"bd821259","138":"e2e89617","270":"dd666a81","387":"4d61303c","404":"7dae82bf","488":"b2a64b34","545":"9c95955a","580":"eed463de","686":"88ad1e38","706":"44ba4c26","728":"6325fa43","801":"aedb924d","888":"5beb4d48"}[chunkId] + ".chunk.js";
};